// extracted by mini-css-extract-plugin
export default {"container":"SuccessMessage_container__REqoc","message":"SuccessMessage_message__8axTT","icon":"SuccessMessage_icon__0Grwb"};